import React from 'react';
import ReactDOM from 'react-dom/client';
import EditModeApp from './modal/EditModeApp';
import './index.css';
// Import localization sync to ensure it initializes immediately
import './localization-sync';

// Initialize the app when the DOM is ready
function initEditMode() {
  // Create mount point if it doesn't exist
  let mountPoint = document.getElementById('edit-mode-root');
  if (!mountPoint) {
    mountPoint = document.createElement('div');
    mountPoint.id = 'edit-mode-root';
    document.body.appendChild(mountPoint);
  }

  // Create React root and render
  const root = ReactDOM.createRoot(mountPoint);
  root.render(
    <React.StrictMode>
      <EditModeApp />
    </React.StrictMode>
  );
}

// Wait for Unity to be ready, then initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEditMode);
} else {
  initEditMode();
}

// Export initialization function for external use
(window as any).initEditMode = initEditMode;